import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {PosterEditorLanguagePanelProps} from '@Panels/poster-editor-language-panel/poster-editor-language-panel';

const PANEL_ID = 'poster-editor-language-panel';

export type PosterEditorLanguageModalProps = PosterEditorLanguagePanelProps;

export default function PosterEditorLanguageModal(): ReactElement<any> {
  const height = '600px';
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_LANGUAGE_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      doesBottomSheetHaveSnapPoints
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-language-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorLanguageModal = (props: PosterEditorLanguageModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_LANGUAGE_MODAL,
      panelProps: {
        panelId: props,
      },
    })
  );
};
